// extracted by mini-css-extract-plugin
module.exports = {"sound_btn":"SoundButton_sound_btn__MGOFY","sound_on":"SoundButton_sound_on__LwDOX","sound_off":"SoundButton_sound_off__Sirf6","current":"SoundButton_current__kFXgQ"};